import { setRef } from "@mui/material";
import { forwardRef, InputHTMLAttributes, useCallback } from "react";
import MaskedInput, { conformToMask } from "react-text-mask";

import { stripNonNumericCharacters } from "../../../lib/strip-non-numeric-characters";

const mask = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

/**
 * Phone number mask, used as the MUI `inputComponent` of tel text fields.
 *
 * MUI passes the input ref as a regular `ref`, so it's forwarded to the
 * `<input>` that `react-text-mask` renders.
 */
export const TelMask = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  const handleMaskedInputRef = useCallback(
    (maskedInput: MaskedInput | null) => {
      setRef(
        ref,
        maskedInput ? (maskedInput.inputElement as HTMLInputElement) : null
      );
    },
    [ref]
  );

  return (
    <MaskedInput
      ref={handleMaskedInputRef}
      pipe={(conformedValue, config: { rawValue: string }) => {
        const numericCharacters = stripNonNumericCharacters(
          config.rawValue || ""
        );

        if (numericCharacters.length === 11 && numericCharacters[0] === "1") {
          // strip off leading one if we think it's the country code (aka +1)
          return conformToMask(numericCharacters.substring(1), mask)
            .conformedValue;
        }

        return conformedValue;
      }}
      mask={mask}
      {...props}
    />
  );
});

TelMask.displayName = "TelMask";
